import { Box } from "@design-system/Layout/Box";
import { FlexCol } from "@design-system/Layout/Flex";
import { Ellipsis } from "@design-system/Typography/Ellipsis";
import { Text } from "@design-system/Typography/Text";
import { cn } from "@design-system/Utilities";
import { type FC } from "react";

export const GroupSidebar: FC<{
    activeGroupId: string | undefined;
    groups: { id: string; name: string }[];
    onActiveGroupIdChange: (groupId: string) => void;
}> = ({ activeGroupId, groups, onActiveGroupIdChange }) => {
    const handleClick = (groupId: string) => {
        return () => {
            onActiveGroupIdChange(groupId);
        };
    };

    return (
        <FlexCol gap="2" className="w-[232px]">
            {groups.map((group) => {
                return (
                    <Box
                        key={group.id}
                        className={cn(
                            "cursor-pointer",
                            activeGroupId === group.id && "bg-tertiary",
                        )}
                        br="lg"
                        p="2"
                        onClick={handleClick(group.id)}
                    >
                        <Ellipsis
                            asChild
                            className="min-w-[224px] max-w-[224px]"
                            hasTooltip
                        >
                            <Text
                                className={
                                    activeGroupId === group.id
                                        ? "text-brand_hover"
                                        : ""
                                }
                            >
                                {group.name}
                            </Text>
                        </Ellipsis>
                    </Box>
                );
            })}
        </FlexCol>
    );
};
